import { commonFacebookEventsUtil } from '@/shared/features/analytics/utils/facebookCommonAttributes';
import type { ListingDesignItem } from '../../domain/models/ProductListing';
import { PLP_SORT_OPTIONS, type PlpSortByValue } from '../../constants';

function sortLabelForValue(value: PlpSortByValue): string {
  const option = PLP_SORT_OPTIONS.find((o) => o.value === value);
  return option?.label ?? value;
}

export interface FacebookPlpViewedParams {
  designs: ListingDesignItem[];
  totalCount?: number;
  sortBy?: PlpSortByValue;
  listName?: string;
}

export function facebookPlpViewed({
  designs,
  totalCount = 0,
  sortBy,
  listName = '',
}: FacebookPlpViewedParams): void {
  if (!designs.length) return;

  const visible = designs.slice(0, 9);
  commonFacebookEventsUtil('PLP Viewed', {
    content_name: visible.map((d) => d.designName),
    content_category: visible[0]?.categoryType ?? '',
    content_ids: visible.map((d) => String(d.designId)),
    content_type: 'product',
    result_count: totalCount > 0 ? String(totalCount) : String(designs.length),
    list_name: listName,
    sort_order: sortBy ? sortLabelForValue(sortBy) : '',
  });
}
